import Vue from 'vue'
import {CONSTANTS_PROD, CONSTANTS_TEST, TEST_ENVIRONMENT} from '../../config/constants'
import axios from 'axios'
import {bus} from '../../components/Product/bus-product'
import _ from "lodash";
import {console} from "vuedraggable/src/util/helper";


export var product_service = new Vue({
    data() {
        return {
            constants: {},
            full_url: ''
        }
    },
    methods: {
        async GetAllProduct() {
            await axios.get(this.full_url + 'search/product_index')
                .then(function (response) {
                    bus.GetAllProduct(_.map(response.data.body.hits.hits, "_source"), response.data.body.hits.total)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllProductSearch(data) {
            await axios.get(this.full_url + 'search/product_index/' + data)
                .then(function (response) {
                    bus.GetAllProduct(_.map(response.data.body.hits.hits, "_source"), response.data.body.hits.total)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllProductPagination(page) {
            await axios({
                method: 'POST',
                url: this.full_url + 'search/product_index',
                data: {
                    from: page,
                    size: 10
                }
            })
                .then(function (response) {

                    bus.GetAllProductPagination(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllProductSku() {
            await axios.get(this.full_url + 'productsku')
                .then(function (response) {
                    bus.GetAllProductSku(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllProductAll() {
            await axios.get(this.full_url + 'product')
                .then(function (response) {
                    bus.GetAllProductAll(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllCategory() {
            await axios.get(this.full_url + 'category')
                .then(function (response) {
                    bus.GetAllCategory(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllProductType() {
            await axios.get(this.full_url + 'produttype')
                .then(function (response) {
                    bus.GetAllProductType(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllUnitType() {
            await axios.get(this.full_url + 'units')
                .then(function (response) {
                    bus.GetAllUnitType(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async CreateProduct(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'product',
                data: data
            })
                .then(function (response) {

                    bus.ResponseCreateProduct(response)


                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async CreateCategory(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'category',
                data: data
            })
                .then(function (response) {
                    bus.ResponseCreateCategory(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async UpdateProduct(data) {
            await axios({
                method: 'PUT',
                url: this.full_url + 'product',
                data: data
            })
                .then(function (response) {

                    bus.ResponseUpdateProduct(response)


                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async CreateProductSku(data) {

            await axios({
                method: 'POST',
                url: this.full_url + 'productsku',
                data: data
            })
                .then(function (response) {
                    bus.ResponseCreateProductSku(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async GetExportProduct() {
            await axios({
                method: 'POST',
                url: this.full_url + 'product/export'
            })
                .then(function (response) {
                    bus.GetExportProduct(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async UpdateProductSku(data) {

            await axios({
                method: 'PUT',
                url: this.full_url + 'productsku',
                data: data
            })
                .then(function (response) {
                    bus.ResponseUpdateProductSku(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async CreateProductInventory(data) {

            await axios({
                method: 'POST',
                url: this.full_url + 'inventory',
                data: data
            })
                .then(function (response) {
                    bus.ResponseCreateProductInventory(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async EditProductInventory(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'inventory',
                data: data
            })
                .then(function (response) {
                    bus.ResponseUpdateProductInventory(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        }
        ,
        async CreateProductSkuGalery(rute, data) {

            var formData = new FormData();
            for (const image in data) {
                formData.append("image", data[image]);
            }


            await axios.post(this.full_url + 'galery/multiple/' + rute, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>'
                }
            })
                .then(function (response) {
                    bus.ResponseCreateProductSkuGalery(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async DeleteSKU(id) {
            let date
            var f = new Date()
            let day = f.getDate()
            let month = f.getMonth() + 1
            let year = f.getFullYear()

            if (month < 10) {

                date = `${year}-0${month}-${day}`
            } else {
                date = `${year}-${month}-${day}`

            }
            let data =
                {
                    sku_product_id: id,
                    deletedAt: date
                }

            await axios({
                method: 'DELETE',
                url: this.full_url + 'productsku',
                data: data
            })
                .then(function (response) {
                    console.log(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        }, async DeleteProduct(id) {
            let date
            var f = new Date()
            let day = f.getDate()
            let month = f.getMonth() + 1
            let year = f.getFullYear()

            if (month < 10) {

                date = `${year}-0${month}-${day}`
            } else {
                date = `${year}-${month}-${day}`

            }
            let data =
                {
                    product_id: id,
                    deletedAt: date
                }
            await axios({
                method: 'DELETE',
                url: this.full_url + 'product/',
                data: data
            })
                .then(function (response) {
                    //console.log(response)
                    bus.ResponseDeleteProduct(response)
                })
                .catch(function (error) {
                    bus.ResponseDeleteProduct('500')
                    console.log('Error ' + error);
                })
        },
        async ImportProducts(data) {
            var formData = new FormData();
            for (const file in data) {
                formData.append("file", data[file]);
            }
console.log(formData)
            await axios.post(this.full_url + 'product/import/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>',
                    'content-type': 'application/vnd.ms-excel;charset=UTF-8'
                }
            })
                .then(function (response) {
                    //bus.ImportProducts(response)
                    console.log(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        }

    },
    created() {
        (TEST_ENVIRONMENT) ? this.constans = CONSTANTS_TEST : this.constans = CONSTANTS_PROD;
        this.full_url = this.constans.URL_API + this.constans.VERSION_API;
    }
})